import React from 'react';

import { pluralizeTours } from 'src/utils/pluralizeUtils';
import { useTranslation } from '@lt/localization';
import SimilarPackagesList from './SimilarPackagesList';
import SimilarPackageHotelButton from './SimilarPackageHotelButton';
import { getPluralOffersType } from './utils';
import type { SimilarPackagesProps } from './types';

const SimilarPackages = ({
  baseCls,
  similarOffers,
  hotelOffersCount = 0,
  hasAdjustParams,
  onClick,
  searchType,
  isHotelOnly,
  isMobile,
}: SimilarPackagesProps) => {
  const { t } = useTranslation();
  const offersIsOld = isHotelOnly
    ? `${getPluralOffersType(searchType, false)} ${t(
        'checkout.similarPackage.oldPackage.neuter',
      )}`
    : `${getPluralOffersType(searchType, false)} ${t(
        'checkout.similarPackage.oldPackage.masculine',
      )}`;
  const title = hasAdjustParams
    ? `${t('checkout.similarPackage.similar')} ${getPluralOffersType(
        searchType,
        true,
      )}`
    : offersIsOld;

  return (
    <>
      <h1 className={`${baseCls}__title`}>{title}</h1>
      <p className={`${baseCls}__message`}>
        {t('checkout.similarPackage.all')}{' '}
        {getPluralOffersType(searchType, true)}{' '}
        {t('checkout.similarPackage.alreadyBuy')}
      </p>

      <ul className={`${baseCls}-list`}>
        {similarOffers.map((offer) => (
          <SimilarPackagesList
            key={offer.id}
            {...offer}
            onClick={onClick}
            isMobile={isMobile}
          />
        ))}
      </ul>

      {hotelOffersCount > 0 && (
        <div className={`${baseCls}__extra-results`}>
          {`Ещё ${hotelOffersCount} ${pluralizeTours(
            hotelOffersCount,
          )} в этот отель`}
        </div>
      )}

      <SimilarPackageHotelButton />
    </>
  );
};

export default SimilarPackages;
